import { ProviderTarget, ProviderTargets } from '@advanza/interfaces/PopUpNotification'
import { Input } from '@advanza/shadcn-ui/src/components/ui/input'
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@advanza/shadcn-ui/src/components/ui/select'
import { FIELDS } from 'hooks/popUpnotificationsHooks'
import { ChangeEvent, useState } from 'react'

interface Props {
    onChangeValue: (value: string) => void
    onChangeSpecificProviders: (event: ChangeEvent<HTMLInputElement>) => void
    value: ProviderTarget
    specificProviders: string[] | undefined
}

const SelectProviderTarget = ({
    onChangeValue,
    value,
    specificProviders,
    onChangeSpecificProviders,
}: Props) => {
    const [selectedValue, setSelectedValue] = useState(value)
    const [disabledSpecificTargets, setDisabledSpecificTargets] = useState(true)
    const [inputValue, setInputValue] = useState(specificProviders?.join(', ') || '')

    const handleChange = (value: any) => {
        onChangeValue(value)
        setSelectedValue(value)
        if (value === ProviderTargets.SPECIFIC) {
            setIsSpecificProviders(true)
        } else {
            setIsSpecificProviders(false)
        }
        setDisabledSpecificTargets(false)
    }

    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        // Only allow numbers and commas
        if (!/^[0-9,\s]*$/.test(value)) {
            return
        }
        setInputValue(value)
        onChangeSpecificProviders(e)
    }

    const [isSpecificProviders, setIsSpecificProviders] = useState(
        selectedValue === ProviderTargets.SPECIFIC,
    )
    return (
        <>
            <Select value={selectedValue} onValueChange={handleChange}>
                <SelectTrigger className="border border-neutral-200 bg-white">
                    <SelectValue style={{ color: 'grey' }} placeholder="Select users target" />
                </SelectTrigger>
                <SelectContent className={'bg-white'}>
                    <SelectGroup>
                        <SelectItem value={ProviderTargets.ALL}>All</SelectItem>
                        <SelectItem value={ProviderTargets.BASIC}>Basic</SelectItem>
                        <SelectItem value={ProviderTargets.PREMIUM}>Premium</SelectItem>
                        <SelectItem value={ProviderTargets.SPECIFIC}>Specific</SelectItem>
                    </SelectGroup>
                </SelectContent>
            </Select>
            {isSpecificProviders && (
                <div className="flex gap-1 items-center">
                    <Input
                        className="p-1 border-neutral-200 bg-white"
                        id={FIELDS.SPECIFIC_TARGETS}
                        disabled={disabledSpecificTargets}
                        onChange={handleInputChange}
                        type="text"
                        placeholder="Target Specific Providers (comma-separated)"
                        value={inputValue}
                    />
                    {disabledSpecificTargets && (
                        <span onClick={() => setDisabledSpecificTargets(false)}>edit</span>
                    )}
                </div>
            )}
        </>
    )
}
export default SelectProviderTarget
